import {email, helpers, required, requiredIf} from "@vuelidate/validators";
import {EXTERNAL_APPEALS_PATIENT_RELATIONSHIPS} from "@/utils/constants.js";

export class ExternalAppealPatientModel {
    constructor(data = {}) {
        this.patientId = data.patientId ?? null;
        this.appealId = data.appealId ?? null;
        this.firstName = data.firstName ?? null;
        this.middleName = data.middleName ?? null;
        this.lastName = data.lastName ?? null;
        this.dob = data.dob ?? null;
        this.phoneNumber = data.phoneNumber ?? null;
        this.email = data.email ?? null;
        this.street = data.street ?? null;
        this.city = data.city ?? null;
        this.state = data.state ?? null;
        this.zipCode = data.zipCode ?? null;
        this.relationshipToPatient = data.relationshipToPatient ?? null;
        this.otherRelationship = data.otherRelationship ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }

    toRequestPayload() {
        return {
            patientId: this.patientId,
            appealId: this.appealId,
            firstName: this.firstName,
            middleName: this.middleName,
            lastName: this.lastName,
            dob: this.dob,
            phoneNumber: this.phoneNumber,
            email: this.email,
            street: this.street,
            city: this.city,
            state: this.state,
            zipCode: this.zipCode,
            relationshipToPatient: this.relationshipToPatient,
            otherRelationship: this.otherRelationship,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt
        };
    }

}
